import React from 'react';
import { Badge } from '@ncoder/ui';

interface DeploymentStatusItemProps {
  label: string;
  value: string | number;
  icon?: React.ReactNode;
  variant?: 'default' | 'secondary' | 'success' | 'warning' | 'destructive';
}

export const DeploymentStatusItem: React.FC<DeploymentStatusItemProps> = ({
  label,
  value,
  icon,
  variant = 'default',
}) => {
  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        {icon && <span className="text-muted-foreground">{icon}</span>}
        <span className="text-sm text-muted-foreground">{label}</span>
      </div>
      <Badge variant={variant as any}>{value}</Badge>
    </div>
  );
};
